<div>
    <img src="../../../assets/imgNotFound.svg" alt="Not Found">
</div>